import React, { useState, useEffect } from 'react';
import { DialogFileUpload } from 'app/pages/Media/components/file-upload';
import { mediaBaseUrl } from 'utils/api/endpoints';
import { useSelector } from 'react-redux';
import { selectUploadedFile } from 'app/pages/Media/slice/selectors';
import { Trash, UploadCloud } from 'lucide-react';
import { MediaAction } from 'app/pages/Media/slice';
import { Button } from 'app/components/ui/button';
import { useDispatch } from 'react-redux';
import { useFormContext } from 'react-hook-form';

export default function FeaturedImage() {
  const form = useFormContext();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const uploadedFile = useSelector(selectUploadedFile);
  const dispatch = useDispatch();

  useEffect(() => {
    if (uploadedFile) {
      form.setValue('featured_image', uploadedFile.key);
    }
  }, [uploadedFile, form]);

  return (
    <div className="max-w-4xl mx-auto px-4 py-10 bg-white  dark:bg-transparent rounded-xl shadow-sm">
      {uploadedFile ? (
        <div className="relative w-full h-[200px] rounded-xl overflow-hidden">
          <img
            src={`${mediaBaseUrl}/${uploadedFile.folder}/${uploadedFile.key}`}
            alt="Featured blog"
            className="w-full h-full object-cover"
          />
          {/* Remove */}
          <div className="absolute top-0 right-0">
            <Button
              onClick={() => dispatch(MediaAction.setUploadedFile(null))}
              className="mt-2 mx-auto bg-red-500 text-white rounded-full w-10 h-10"
            >
              <Trash className="w-5 h-5" />
            </Button>
          </div>
        </div>
      ) : (
        <div
          onClick={() => setIsDialogOpen(true)}
          className="w-full h-[200px] rounded-xl flex flex-col items-center justify-center text-gray-500 border border-dashed border-gray-300 cursor-pointer hover:bg-gray-200 transition-colors"
        >
          <UploadCloud className="w-8 h-8 mb-2" />
          <span>Upload Featured Image</span>
        </div>
      )}

      <DialogFileUpload
        isOpen={isDialogOpen}
        onOpenChange={setIsDialogOpen}
        folder="blogs"
      />
    </div>
  );
}
